import { useCallback, useState } from 'react';
import { isNodeOverflowing } from '../../../../CommonUtils/isNodeOverflowing';

export const useOverflowingItemsCount = () => {
  const [overflowingItemsCount, setOverflowingItemsCount] = useState(0);

  const ref = useCallback(
    node => {
      if (!node) {
        return;
      }

      if (isNodeOverflowing(node)) {
        setOverflowingItemsCount(overflowingItemsCount + 1);
      }
    },
    [overflowingItemsCount],
  );

  return { ref, overflowingItemsCount };
};
